// 西班牙语
const esImg = {}
// 葡萄牙语
const ptImg = {}
// 英语
const enImg = {}
// 简中
const cnImg = {}
// 繁中
const tcImg = {};
// 泰语
const thImg = {};
// 印尼语
const idImg = {};

const imgMap = {
  '--boost-ticket': 'boost_ticket.png',
  '--invite-friends': 'invite_friends.png',
  '--sign-in-rewards': 'sign_in_rewards.png'
}
Object.keys(imgMap).forEach((key) => {
  cnImg[key] = `url('${
    new URL(`./cn/${imgMap[key]}`, import.meta.url).href
  }')`;
  enImg[key] = `url('${
    new URL(`./en/${imgMap[key]}`, import.meta.url).href
  }')`;
  esImg[key] = `url('${
    new URL(`./es/${imgMap[key]}`, import.meta.url).href
  }')`;
  ptImg[key] = `url('${
    new URL(`./pt/${imgMap[key]}`, import.meta.url).href
  }')`;
  idImg[key] = `url('${
    new URL(`./id/${imgMap[key]}`, import.meta.url).href
  }')`;
  thImg[key] = `url('${
    new URL(`./th/${imgMap[key]}`, import.meta.url).href
  }')`;
  tcImg[key] = `url('${
    new URL(`./tc/${imgMap[key]}`, import.meta.url).href
  }')`;
})

export { enImg, ptImg, esImg, cnImg, idImg, thImg, tcImg }
